import { ReactNode, createContext, useState, useMemo } from "react";

export type UpdateInfoContextType = {
  updateAt: string;
  setUpdateAt: (value: string) => void;
};

export const UpdateInfoContext = createContext<UpdateInfoContextType>({
  updateAt: "",
  setUpdateAt: () => {},
});

export const UpdateInfoContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [updateAt, setUpdateAt] = useState<string>("");

  const contextValue = useMemo(
    () => ({
      updateAt,
      setUpdateAt,
    }),
    [updateAt]
  );

  return (
    <UpdateInfoContext.Provider value={contextValue}>
      {children}
    </UpdateInfoContext.Provider>
  );
};
